
import { useNavigate } from "react-router-dom";
import { Progress } from "@/components/ui/progress";
import { StarRating } from "./StarRating";
import { RankIcon } from "./RankIcon";
import type { AirportLeaderboardStats } from "@/types/airport";
import { useTranslation } from "@/hooks/useTranslation";

interface MobileLeaderboardProps {
  airportStats: AirportLeaderboardStats[];
  showWorst: boolean;
}

export const MobileLeaderboard = ({ airportStats, showWorst }: MobileLeaderboardProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleAirportClick = (airportName: string) => {
    // Encode the airport name to handle spaces and special characters in URLs
    const encodedAirportName = encodeURIComponent(airportName);
    navigate(`/airport/${encodedAirportName}`);
  };

  return (
    <div className="space-y-3">
      {airportStats.map((airport, index) => (
        <div
          key={airport.airport_id}
          className="p-3 border rounded-lg bg-card cursor-pointer hover:bg-muted/50"
          onClick={() => handleAirportClick(airport.airport_name)}
        >
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-6">
              <RankIcon rank={index} isWorst={showWorst} />
            </div>
            <div className="flex-1 min-w-0">
              <div 
                className="font-medium line-clamp-1 hover:line-clamp-none max-w-[220px]"
                title={t(airport.airport_name) || airport.airport_name}
              >
                {t(airport.airport_name) || airport.airport_name}
              </div>
              <div className="flex items-center justify-between mt-1">
                <StarRating score={airport.average_score} isMobile={true} />
                <div className="flex items-center gap-2">
                  <Progress 
                    value={airport.hand_check_success_rate} 
                    className={`h-2 w-16 ${showWorst ? 'bg-muted' : ''}`}
                  />
                  <span className="text-xs min-w-[32px] text-right">
                    {airport.hand_check_success_rate.toFixed(0)}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
